import 'slick-carousel';
import {AnimationService} from "../service/animation";
import FocusProductSlide from "../animations/product-slide/focus-product-slide";
import UnfocusProductSlide from "../animations/product-slide/unfocus-product-slide";
import {AbstractCarouselComponent} from "./abstract-carousel";
import EventsHandler from "../service/events";
import EVENTS from "../constants/events";
import {ScrollService} from "../service/scroll";

export class ProductVariationsComponent {

    private $root: JQuery;
    private $iframe: JQuery<HTMLIFrameElement>;
    private $variations: JQuery;

    constructor(elem: HTMLElement) {
        this.$root = $(elem);
        this.$iframe = $('#pcon-ui-iframe');
        this.$variations = this.$root.find('.js-product-variations__variation')
    }

    init() {
        this.$variations
            .find('.js-product-variations__variation-link')
            .on('click', this.handleClick);
    }

    handleClick = (ev:any) => {
        ev.preventDefault();
        if (this.$iframe.length != 0) {
            let $target = $(ev.currentTarget);
            let link = $target.data('iframe');
            if (undefined != link) {
                this.$iframe.attr('src', link);
                this.$iframe.get(0).contentWindow.location.reload();
                ScrollService.scrollTo('#pcon-ui-iframe', null, 115);
            }
        }
    }
}
